<template>
  <section class="content">
    <!-- Default box -->
    <div class="box">
            <div class="box-header">
              <h3 class="box-title"><b>Report</b></h3>
              <hr>
            </div>
            <!-- /.box-header -->
            <div class="box-body" style="min-height: 800px;height: auto;">
              <div id="example1_wrapper" class="dataTables_wrapper form-inline dt-bootstrap">
                <div class="row">
                  <div class="col-sm-12">
                    <!-- <div class="box-header with-border" style="background-color: #f1f1f1;">Detailed List</div> -->
                    <div class="box-header with-border" style="padding: 11px;padding-right: 0px;">
                      <h3 class="box-title"></h3>
                      <div class="filterDivclass form-group pull-left" style="height:30px !important;">
                        <div class="form-select" style="height:30px !important;">
                          <select
                            class="form-control"
                            placeholder="Select Type"
                            style="height:30px;min-width:150px; border: 1px solid lightgrey !important;"
                            v-model="postType"
                            @change="getalldata()"
                          >
                            <option value="" selected
                              >Select Type</option
                            >
                            <option value="jd">JD</option>
                            <option value="id">ID</option>
                          </select>
                          <span class="select-icon"
                            ><i class="fa fa-chevron-down"></i
                          ></span>
                        </div>
                      </div>
                      <div class="box-tools" style="width: 500px;">
                        <Datepicker
                        v-model="selectedDate" position="right" lang="en"
                        range/>
                          <a @click="openExcel()" class="btn btn-sm btn-primary pull-right">
                            Export
                            <!-- <export-excel :data="json_data"> -->
                              <!-- <a href="javascript:void(0)" id="expbtn" class="btn btn-sm btn-primary pull-right"></a> -->
                            <!-- </export-excel> -->
                          </a>
                          <export-excel id="expbtn" class="expbtn" name="scheduleList" :data="json_data">
                            <a href="javascript:void(0)"></a>
                          </export-excel>
                          <!-- <export-excel name="summary" :data="json_data">
                            <a href="javascript:void(0)" @click="open()" class="btn btn-sm btn-primary pull-right">Export</a>
                          </export-excel> -->
                          <button class="mr-2 btn btn-sm sbtn pull-right" @click="getDate()">Apply</button>
                          <button class="mr-2 btn btn-sm btn-default pull-right" @click="clearData()">Clear</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div style="margin-top: 20%;text-align:center" v-if="userslistlength < 1">
                      <img src="../assets/img/nodata.svg" alt="Product Image" style="width: 80px;">
                    </div>
                    <div class="table-responsive text-nowrap">
                  <table v-if="userslistlength > 0" id="example1" class="table table-striped" role="grid" aria-describedby="example1_info" style="font-size:12px">
                <thead>
                  <tr role="row">
                    <th class="sorting_asc" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-sort="ascending" aria-label="Rendering engine: activate to sort column descending" style="width: 44px;">S.No</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Post Title</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending" v-if="email == 'naren.v@screenit.io'">Organization Name</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Client Name</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Platform(s): activate to sort column ascending">Interview Status</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Platform(s): activate to sort column ascending">Interviewer Name</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Engine version: activate to sort column ascending">Interviewer Experience</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Candidate Name</th>
                    <!-- <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Candidate Experience</th> -->
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Interviewer Cost</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Screenit Score</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Interviewed Date</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Interviewed Time</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Verdict</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Candidate No Show</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Candidate Proxy</th>
                  </tr>
                </thead>
                <tbody>
                  <tr role="row" class="odd" v-for="(x, index) in userslist" :key="x.id">
                    <td>{{((skip-1) * 10 ) + (index+1) }}</td>
                    <td>{{x.post.job_title}}</td>
                    <td v-if="email == 'naren.v@screenit.io'">{{x.post.org_name}}</td>
                    <td>{{x.post.client_name}}</td>
                    <td v-if="x.feedback[0].interview_status === 'Incomplete'" style="color:red;">{{x.feedback[0].interview_status}}</td>
                    <td v-if="x.feedback[0].interview_status !== 'Incomplete'">{{x.feedback[0].interview_status}}</td>
                    <td>{{x.interviewer.candidate.first_name + ' ' + x.interviewer.candidate.last_name}}</td>
                    <td>{{x.interviewer.candidate.year_of_experience}} Years {{x.interviewer.candidate.month_of_experience}} Months</td>
                    <td>{{x.candidate.first_name + ' '}}{{x.candidate.last_name!= null ? x.candidate.last_name : '' }}</td>
                    <!-- <td>{{x.candidate_year_of_experience}} Years {{x.candidate_month_of_experience}} Months</td> -->
                    <td><i class="uil uil-rupee-sign"></i>{{userInfo.paid}}</td>
                    <!-- <td><span v-if="x.result == 'yes' || x.result == 'Yes'" style="color:#5bad2b">Eligible</span><span v-if="x.result == 'No' || x.result == 'no'" style="color:red">Not Eligible</span><span class="tc" v-if="x.result == null || x.result == ''">--</span></td> -->
                    <td style="color:#5bad2b" v-if="x.feedback[0].sit_score !==0">{{x.feedback[0].sit_score}}/10</td>
                    <td v-if="x.feedback[0].sit_score ===0">--</td>
                    <td>{{getDate1(x.utc_starttime)}}</td>
                    <td>{{getTime1(x.utc_starttime)}} to {{getTime1(x.utc_endtime)}}</td>
                    <td>
                      <span v-if="x.feedback[0].sit_score < 5">Rejected</span>
                      <span v-else-if="x.feedback[0].sit_score < 7">Near Fit</span>
                      <span v-else-if="x.feedback[0].sit_score < 9">Hire</span>
                      <span v-else-if="x.feedback[0].sit_score > 8">Strong Hire</span>
                    </td>
                    <td>
                      <span v-if="!x.feedback[0].candidate_no_show">No</span>
                      <span v-if="x.feedback[0].candidate_no_show">Yes</span>
                    </td>
                    <td>
                      <span v-if="!x.feedback[0].proxy">No</span>
                      <span v-if="x.feedback[0].proxy">Yes</span>
                    </td>
                  </tr>
                </tbody>
              </table></div></div></div>
              <div class="row" v-if="userslistlength > 9">
                <div class="col-sm-3">
                  <div class="dataTables_info" id="example1_info" role="status" aria-live="polite"></div>
                </div>
                <div class="col-sm-7">
                  <jw-pagination :items="exampleItems" @changePage="onChangePage"></jw-pagination>
                </div>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
            <div class="modal overlay fade in" id="myModal1">
              <div class="modal-dialog" style="margin-top:115px !important;width: 450px !important;">
                <div class="modal-content" style="width: 450px;margin-left: auto;margin-right: auto;border-radius: 7px;">
                  <div class="modal-body" style="padding:0px">
                    <div class="row" >
                      <div class="col-md-12 " style="padding:17px">
                        <div class="col-md-12" style="text-align: center;">
                          <p style="font-size: 20px;font-weight: 600;">Candidate No Show</p><br>
                          <button class="btn btn-success" @click="closeViolated()">Ok</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /.modal-content -->
              </div>
            </div>
          </div>
  </section>
</template>

<script>

import axios from 'axios'
import { BaseURLV3 } from '../shared/classes'
import excel from 'vue-excel-export'
import router from '../router/index'
import Vue from 'vue'
import JwPagination from 'jw-vue-pagination'
import $ from 'jquery'
import moment from 'moment'
import VueDatepickerUi from 'vue-datepicker-ui'
import 'vue-datepicker-ui/lib/vuedatepickerui.css'
import momentsone from 'moment-timezone'

Vue.component('Datepicker', VueDatepickerUi)
Vue.component('jw-pagination', JwPagination)
Vue.use(excel)
export default {
  name: 'tabs-card',
  data () {
    return {
      title: '',
      pageOfItems: [],
      totalPages: 0,
      pages: [],
      showlist: false,
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      viewdetails: false,
      showRole: false,
      adduser: true,
      userslistlength: '',
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      json_data: [],
      postdetails: [],
      email: '',
      base_urls: BaseURLV3,
      userRole: '',
      selectedDate: [],
      disabledEndDate: {
        to: new Date('01.02.2221'),
        from: new Date(new Date().getDate() + 1)
      },
      startDate: '',
      endDate: '',
      exampleItems: [],
      skip: 1,
      timezone: momentsone.tz.guess(),
      reasonList: [],
      postType: 'id',
      userslist: []
    }
  },
  components: {
    Datepicker: VueDatepickerUi
  },
  created () {
    this.getalldata()
    this.getReasons()
  },
  methods: {
    getDate (e) {
      // this.startDate = moment(this.selectedDate[0]).format('YYYY-MM-DD')
      // this.endDate = moment(this.selectedDate[1]).format('YYYY-MM-DD')
      this.startDate = moment(this.selectedDate[0]).utc().format('YYYY-MM-DD HH:mm')
      this.endDate = moment(this.selectedDate[1]).utc().add(1, 'd').format('YYYY-MM-DD HH:mm')
      this.getalldata()
    },
    getDate1 (date) {
      return moment(date).utc().tz(this.timezone).format('DD MMM YYYY')
    },
    getTime1 (date) {
      return moment(date).utc().tz(this.timezone).format('hh:mm a')
    },
    clearData () {
      this.selectedDate = []
      this.startDate = ''
      this.endDate = ''
      // this.getPostdataRange()
      this.getalldata()
    },
    openExcel () {
      console.log('openExcel')
      const data = {
        type: this.postType,
        from: this.startDate,
        to: this.endDate
      }
      const mainurl = '/org/' + this.userInfo.id + '/export_interview_report'
      axios.post(`${BaseURLV3}${mainurl}`, data, this.config).then(response => {
        if (response.data.success) {
          const datas = response.data.schedule
          const data = []
          for (let index = 0; index < datas.length; index++) {
            const element = datas[index]
            if (element.feedback[0].sit_score < 5) {
              element.verdict = 'Rejected'
            } else if (element.feedback[0].sit_score < 7) {
              element.verdict = 'Near Fit'
            } else if (element.feedback[0].sit_score < 9) {
              element.verdict = 'Hire'
            } else if (element.feedback[0].sit_score > 8) {
              element.verdict = 'Strong Hire'
            }
            const val = {
              PostTitle: element.post.job_title,
              InterviewerName: element.interviewer.candidate.first_name + ' ' + element.interviewer.candidate.last_name,
              InterviewedDate: this.getDate1(element.utc_starttime),
              InterviewedTime: this.getTime1(element.utc_starttime) + ' ' + this.getTime1(element.utc_endtime),
              CandidateName: element.candidate.first_name + ' ' + element.candidate.last_name,
              CandidateEmail: element.candidate.email,
              // ScreenitScore: element.result,
              InterviewStatus: '',
              Verdict: element.verdict,
              CandidateNoShow: element.feedback[0].candidate_no_show ? 'Yes' : 'No',
              CandidateProxy: element.feedback[0].proxy ? 'Yes' : 'No',
              ReasonForInComplete: this.getreasonName(element.feedback[0].incomplete_reason_id)
            }
            if (this.showRole) {
              if (element.candidate_no_show === 'Yes') {
                val.InterviewStatus = 'InComplete'
              } else {
                val.InterviewStatus = 'Complete'
              }
              delete val.ReasonForInComplete
              delete val.ScreenitScore
            } else {
              if (element.feedback[0].interview_status === 'Incomplete') {
                val.InterviewStatus = 'InComplete'
              } else {
                val.InterviewStatus = 'Complete'
              }
            }
            data.push(val)
          }
          this.json_data = data
          if (this.json_data.length !== 0) {
            $('#expbtn').click()
          }
        }
      }).catch(e => {
        console.log(e)
      })
    },
    viewasFeedback (id) {
      const routerPage = this.$router.resolve('/viewfeedbackcommon/' + id)
      window.open(routerPage.href, '_blank')
      // window.open('/viewfeedbackcommon/' + this.sid)
    },
    closeViolated () {
      $('#myModal1').modal('hide')
    },
    openViolated () {
      $('#myModal1').modal('show')
    },
    getalldata () {
      const data = {
        type: this.postType,
        from: this.startDate,
        to: this.endDate,
        page: this.skip
      }
      const mainurl = '/org/' + this.userInfo.id + '/interview_report'
      axios.post(`${BaseURLV3}${mainurl}`, data, this.config).then(response => {
        if (response.data.success) {
          this.userslist = []
          const datas = response.data.schedule
          this.userslist = datas
          this.userslistlength = response.data.total
          this.exampleItems = [...Array(response.data.total).keys()].map(i => (i))
          const data = []
          for (let index = 0; index < datas.length; index++) {
            const element = datas[index]
            if (element.feedback[0].sit_score < 5) {
              element.verdict = 'Rejected'
            } else if (element.feedback[0].sit_score < 7) {
              element.verdict = 'Near Fit'
            } else if (element.feedback[0].sit_score < 9) {
              element.verdict = 'Hire'
            } else if (element.feedback[0].sit_score > 8) {
              element.verdict = 'Strong Hire'
            }
            const val = {
              PostTitle: element.post.job_title,
              InterviewerName: element.interviewer.candidate.first_name + ' ' + element.interviewer.candidate.last_name,
              InterviewedDate: this.getDate1(element.utc_starttime),
              InterviewedTime: this.getTime1(element.utc_starttime) + ' ' + this.getTime1(element.utc_endtime),
              CandidateName: element.candidate.first_name + ' ' + element.candidate.last_name,
              CandidateEmail: element.candidate.email,
              // ScreenitScore: element.result,
              InterviewStatus: '',
              Verdict: element.verdict,
              CandidateNoShow: element.feedback[0].candidate_no_show ? 'Yes' : 'No',
              CandidateProxy: element.feedback[0].proxy ? 'Yes' : 'No',
              ReasonForInComplete: this.getreasonName(element.feedback[0].incomplete_reason_id)
            }
            if (this.showRole) {
              if (element.candidate_no_show === 'Yes') {
                val.InterviewStatus = 'InComplete'
              } else {
                val.InterviewStatus = 'Complete'
              }
              delete val.ReasonForInComplete
              delete val.ScreenitScore
            } else {
              if (element.feedback[0].interview_status === 'Incomplete') {
                val.InterviewStatus = 'InComplete'
              } else {
                val.InterviewStatus = 'Complete'
              }
            }
            data.push(val)
          }
          // this.json_data = data
        }
      }).catch(e => {
        console.log(e)
      })
    },
    onChangePage (pageOfItems) {
      // update page of items
      console.log('abc ', pageOfItems[0])
      if (pageOfItems.length > 0) {
        if (pageOfItems[0] === 0) {
          this.skip = 1
        } else {
          this.skip = (pageOfItems[0] / 10) + 1
        }
      }
      const data = {
        type: this.postType,
        from: this.startDate,
        to: this.endDate,
        page: this.skip
      }
      const mainurl = '/org/' + this.userInfo.id + '/interview_report'
      axios.post(`${BaseURLV3}${mainurl}`, data, this.config).then(response => {
        if (response.data.success) {
          this.userslist = []
          const datas = response.data.schedule
          this.userslist = datas
          // this.userslistlength = response.data.total
          // this.exampleItems = [...Array(response.data.total).keys()].map(i => (i))
          const data = []
          for (let index = 0; index < datas.length; index++) {
            const element = datas[index]
            if (element.feedback[0].sit_score < 5) {
              element.verdict = 'Rejected'
            } else if (element.feedback[0].sit_score < 7) {
              element.verdict = 'Near Fit'
            } else if (element.feedback[0].sit_score < 9) {
              element.verdict = 'Hire'
            } else if (element.feedback[0].sit_score > 8) {
              element.verdict = 'Strong Hire'
            }
            const val = {
              PostTitle: element.post.job_title,
              InterviewerName: element.interviewer.candidate.first_name + ' ' + element.interviewer.candidate.last_name,
              InterviewedDate: this.getDate1(element.utc_starttime),
              InterviewedTime: this.getTime1(element.utc_starttime) + ' ' + this.getTime1(element.utc_endtime),
              CandidateName: element.candidate.first_name + ' ' + element.candidate.last_name,
              CandidateEmail: element.candidate.email,
              // ScreenitScore: element.result,
              InterviewStatus: '',
              Verdict: element.verdict,
              CandidateNoShow: element.feedback[0].candidate_no_show ? 'Yes' : 'No',
              CandidateProxy: element.feedback[0].proxy ? 'Yes' : 'No',
              ReasonForInComplete: this.getreasonName(element.feedback[0].incomplete_reason_id)
            }
            if (this.showRole) {
              if (element.candidate_no_show === 'Yes') {
                val.InterviewStatus = 'InComplete'
              } else {
                val.InterviewStatus = 'Complete'
              }
              delete val.ReasonForInComplete
              delete val.ScreenitScore
            } else {
              if (element.feedback[0].interview_status === 'Incomplete') {
                val.InterviewStatus = 'InComplete'
              } else {
                val.InterviewStatus = 'Complete'
              }
            }
            data.push(val)
          }
          // this.json_data = data
        }
      }).catch(e => {
        console.log(e)
      })
    },
    getReasons () {
      axios.get(this.base_urls + '/interviewer/cancel_reason', this.config).then(response => {
        this.reasonList = response.data.reason
      }).catch(e => {
      })
    },
    getreasonName (id) {
      var name = ''
      if (this.reasonList.length !== 0) {
        this.reasonList.forEach(element => {
          if (element.id === id) {
            console.log('element ', element)
            name = element.name
          }
        })
      }
      return name
    },
    navigation (tabs) {
      router.push({ name: tabs })
    },
    viewFeedback (id) {
      const route = router.resolve({ name: 'Viewfeedback', params: { id: id } })
      window.open(route.href, '_blank')
    },
    postDetails (pid) {
      const mainurl = '/dashboard/get_post_details_web/' + pid
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.postdetails = response.data.postInfo[0]
        localStorage.setItem('postId', JSON.stringify(this.postdetails))
        router.push({ name: 'Post' })
      }).catch(e => {
        console.log(e)
      })
    }
  }

}
</script>

<style scoped>
.products-list .item:hover {
  border-left: 3px solid #ffffff;
  background-color: #ffffff;
  cursor: pointer;
}
a:hover, a:active, a:focus {
  outline: none;
  text-decoration: none;
  color: #5bad2b;
}
.errorshow {
  background-color: #ff000047;
  padding: 5px;
  color: #dd4b39 !important;
}
.post li.active {
  background-color: #5bad2b !important;
  color: white;
  border: 0px !important;
}
.sideborder {
  border-right: 1px solid #cccccc52;
  min-height: 700px;
  height: 100%;
}
span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 2.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 4px;
}
hr {
  margin-top: 9px;
  margin-bottom: 9px;
}
.tc {
  text-align: center;
}
.table>thead>tr>th {
    border: 2px solid #f4f4f4;
    text-align: center;
}
.table>tbody>tr>td {
    border: 2px solid #f4f4f4;
    text-align: center;
}
</style>
